const initialState = {
  MasterData: {},
};
// //Mock Data
// const Data = {
//   City_MasTer: {
//     city: "HyderaBad",
//    name:"hyddd"
//   },
//   Book_Code: {
//     code: "23",
//   },
// };

function setKeysToEmptyStrings(obj, keys) {
  // Create a new object to avoid mutating the original one
  const newObj = { ...obj };

  // Iterate over the keys of the new object
  for (const key in newObj) {
    if (newObj.hasOwnProperty(key)) {
      // Check if the value is an object and if it contains any of the specified keys
      if (typeof newObj[key] === "object" && !Array.isArray(newObj[key]) && newObj[key] !== null) {
        // Iterate over the properties of the nested object
        for (const nestedKey in newObj[key]) {
          if (keys.includes(nestedKey)) {
            newObj[key][nestedKey] = undefined;
          }
        }
      }
    }
  }

  return newObj;
}

function getKeysExcluding(obj, excludeKey) {
  return Object.keys(obj).filter((key) => key !== excludeKey);
}

export function FormDataReducer(state = initialState, { type, payload }) {
  // console.log(type, payload, "typetype");
  switch (type) {
    case "FORM_DATA_LIST": {
      const { formKey, fieldKey, data } = payload;
      const data1 = state[formKey];
      const result = data1?.[fieldKey] || {};
      return {
        ...state,
        [formKey]: {
          ...state[formKey],
          [fieldKey]: {
            ...result, // Ensures all existing data is carried forward
            ...data, // Applies new data, which should include all fields of the section to avoid omission
          },
        },
      };
    }

    case "StoreMasterData": {
      let { formkey } = payload;
      console.log(payload, "StoreMasterData");
      return {
        ...state,
        MasterData: {
          ...state.MasterData,
          [formkey]: {
            ...state.MasterData[formkey],
            ...payload.data,
          },
        },
      };
    }
    case "StoreMasterDataForRow": {
      let { formkey, rowId, data } = payload;
      let rowData = state.MasterData[formkey]?.[rowId] || {};
      return {
        ...state,
        MasterData: {
          ...state.MasterData,
          [formkey]: {
            ...state.MasterData[formkey],
            [rowId]: { ...rowData, ...data },
          },
        },
      };
    }

    case "CLEAR_MASTER_DROPDOWN": {
      const { formKey } = payload; // Changed 'key' to 'formKey' to match the dispatch
      let masterData = state.MasterData;
      let branchCode = masterData[formKey]?.Branch_Code;
      let masterKeys = getKeysExcluding(masterData[formKey], "Branch_Code");
      let newObj = setKeysToEmptyStrings(state[formKey], masterKeys);
      delete masterData[formKey];
      const newState = {
        ...state,
        [formKey]: newObj,
        MasterData: { ...masterData, [formKey]: { Branch_Code: branchCode } },
      };

      return newState;
    }

    case "CLEAR_SPECIFIC_FORM": {
      const { formKey } = payload; // Changed 'key' to 'formKey' to match the dispatch
      let masterData = state.MasterData;
      delete masterData[formKey];
      const newState = { ...state, MasterData: masterData };
      delete newState[formKey]; // Use formKey to delete the correct key from state

      return newState;
    }

    case "CLEAR_ALL_FORM_DATA": {
      return initialState;
    }
    default:
      return state;
  }
}
